import * as moment from 'moment';
import { environment } from 'src/environments/environment';
 
export class IndividualOperationRequest {
  documentType?: string;
  documentNumber?: string;
  page: number;
  search: string;
  startDate: Date;
  endDate: Date;
  force: boolean;
 
  
  orderBy?: string | null;         
  orderDirection?: string | null;   
  estado?: string | null;
 
  public static toRequest(
    individualOperationRequest: IndividualOperationRequest
  ): any {
 
    const baseRequest: any = {
      tipo_documento: individualOperationRequest.documentType,
      documento: individualOperationRequest.documentNumber,
      id_pais: 1,
      pagina: individualOperationRequest.page,
      registros: 10,
      busqueda: individualOperationRequest.search
        ? individualOperationRequest.search
        : 0,
      fecha_inicial: moment(individualOperationRequest.startDate).format(
        'YYYYMMDD'
      ),
      fecha_final: moment(individualOperationRequest.endDate).format(
        'YYYYMMDD'
      ),
    };
 
    
    if (individualOperationRequest.orderBy && individualOperationRequest.orderDirection) {
      baseRequest.ordenar = individualOperationRequest.orderBy;
      baseRequest.ordenamiento = individualOperationRequest.orderDirection;
    }
 
    if (environment.postgres) {
      return {
        ...baseRequest,
        fecha_inicial: moment(individualOperationRequest.startDate).format(
          'DD-MM-YYYY'
        ),
        fecha_final: moment(individualOperationRequest.endDate).format(
          'DD-MM-YYYY'
        ),
        force: true
      };
    }
 
    return baseRequest;
  }
}